<template>
  <div class='hello'>
<p>下記のボタンクリックで
  LOCALSTORAGEをクリアします
</p>
<button @click="setItem('fav','[]')">お気に入り</button>
<button @click="setItem('view','[]')">最近見た物件</button>
<button @click="setItem('search','[]')">検索履歴</button>
  </div>
</template>

<script>
export default {
  name: 'Admin',
  data() {
    return {
      title: {
        current: '[search]タイトルタイトルタイトル',
        new: '',
      },
      keyword: {
        current: '[search]キーワードキーワードキーワード',
        new: '',
      },
      description: {
        current: '[search]説明文説明文説明文説明文説明文説明文説明文説明文説明文説明文説明文説明文説明文説明文説明文説明文説明文説明文説明文説明文説明文説明文説明文説明文',
        new: '',
      },
    };
  },
  methods: {
    setItem(q, p) {
      localStorage.setItem(q, p);
    },
  },
};
</script>

<style scoped lang='scss'>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.c-form{
 width: 400px;
}
.c-tarea{
  width: 400px;
  height: 200px;
}
</style>
